import { useState } from 'react'
import { Text } from '@/ui'
import { mtc, TypographyStyles } from '@/styles'

export const initialsOf = (name: string): string =>
  name
    .split(' ')
    .slice(0, 2)
    .map((word) => word.charAt(0).toUpperCase())
    .join('')

const MERCHANT_TILE_TONES = [
  { background: 'bg-orange-0', color: 'text-orange-200' },
  { background: 'bg-yellow-0', color: 'text-yellow-200' },
  { background: 'bg-purple-0', color: 'text-purple-200' },
  { background: 'bg-blue-0', color: 'text-blue-200' },
  { background: 'bg-pink-0', color: 'text-pink-200' },
]

const toneFor = (name: string) => {
  const hash = [...name].reduce(
    (total, char) => (total * 31 + char.charCodeAt(0)) >>> 0,
    0
  )
  return MERCHANT_TILE_TONES[hash % MERCHANT_TILE_TONES.length]
}

/** The merchant's logo when there is one, else an initials tile toned by name so merchants tell apart. */
export const MerchantLogo = ({
  name,
  logoUrl,
}: {
  name: string
  logoUrl?: string | null
}) => {
  const [broken, setBroken] = useState(false)
  if (logoUrl && !broken) {
    // A raw img because the design system's Image has no load-error fallback.
    return (
      <img
        src={logoUrl}
        alt=""
        onError={() => setBroken(true)}
        className="size-8 shrink-0 rounded-lg border border-neutral-100 object-cover"
      />
    )
  }
  const { background, color } = toneFor(name)
  return (
    <div
      aria-hidden
      className={mtc(
        'flex size-8 shrink-0 items-center justify-center rounded-lg',
        background
      )}
    >
      <Text variant={TypographyStyles.LABEL_SM} className={color}>
        {initialsOf(name)}
      </Text>
    </div>
  )
}
